<template>
	<div>
		
		
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			
			<el-form-item label="版本号" prop="version">
				<el-input size="small" v-model="ruleForm.version"></el-input>
			</el-form-item>
			
			<el-form-item label="更新方式:" prop="types">
				<el-select v-model="ruleForm.types">
					<el-option value="hot" label="热更新"></el-option>
					<el-option value="apk" label="新安装"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="备注:" prop="content">
				<el-input size="small" v-model="ruleForm.content"></el-input>
			</el-form-item>
			
			<el-form-item label="资源包:" prop="url">
				<el-upload class="upload-demo" :multiple="false" drag :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError">
				  <i class="el-icon-upload"></i>
				  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				  <div class="el-upload__tip" slot="tip">只能上传wgt/apk文件，且不超过500kb</div>
				</el-upload>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">立即添加</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				
				ruleForm: {
					url: '',
					types:'',
					param:'',
					content: ''
				},
				rules: {
					url: [{required: true, message: '请上传资源包', trigger: 'blur'}],
					types: [{required: true, message: '请选择跳转类型', trigger: 'blur'}],
					version: [{required: true, message: '请输入版本号', trigger: 'blur'}],
					content: [{required: true, message: '请输入更新内容', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.ruleForm.url = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Set/addVersion", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 180px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
		border:dashed 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 180px;
	    height: 90px;
	    display: block;
	  }
</style>